<ng-container *ngIf="isRestaurantOrdered">
    <app-restaurant></app-restaurant>
</ng-container>
<ng-container *ngIf="!isRestaurantOrdered">
    <app-track></app-track>
</ng-container>